module.exports = __webpack_public_path__ + "img/ScreenCap_Down_36dp.1ce456a5.svg";